import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <p>
          &copy; {currentYear} DealMapMobile
        </p>
      </div>
    </footer>
  );
};

export default Footer; 